export { AnalyticsProvider, useAnalytics } from './posthog';